import styled from '@emotion/styled';
import { Text } from '~/shared/components';
import { breakpoints, getClampFullRange } from '~/theme';

export const StyledP180 = styled.article(({ theme }) => ({
    [breakpoints.sm]: {
        display: 'grid',
        gap: theme.gridConfig.gap,
        gridTemplateColumns: `repeat(${theme.gridConfig.columnCount.xs}, 1fr)`,
        gridTemplateAreas: `"b b b a a a"
                            "c c c a a a"`,
    },
    [breakpoints.md]: {
        gridTemplateColumns: `repeat(${theme.gridConfig.columnCount.md}, 1fr)`,
        gridTemplateAreas: `"b b b b . a a a a a a a"
                            "c c c c . a a a a a a a"`,
    },
    [breakpoints.lg]: {
        gridTemplateAreas: `"b b b b . a a a a a a a"
                            ". c c c . a a a a a a a"`,
    },
}));

export const StyledP180BreadcrumbWrapper = styled.div(({ theme }) => ({
    gridArea: 'b', // breadcrumb
    marginTop: getClampFullRange(theme.spacesRaw[3], theme.spacesRaw[4]),
}));

export const StyledP180Content = styled.div(({ theme }) => ({
    gridArea: 'c', // content
    padding: `${theme.spaces[3]} 0 ${theme.spaces[4]}`,
    [breakpoints.md]: {
        padding: `${getClampFullRange(theme.spacesRaw[6], theme.spacesRaw[8])} 0 0`,
    },
}));

export const StyledP180Aside = styled.aside({
    gridArea: 'a', // aside
});

export const StyledP180ImageWrapper = styled.div(({ theme }) => ({
    margin: `0 calc(${theme.gridConfig.gutter} * -1)`, // Extend image to edge of screen
    aspectRatio: '4/3',
    [breakpoints.sm]: {
        margin: 0,
        width: `calc(100% + ${theme.gridConfig.gutter})`, // Extend image to edge of screen
        minHeight: '50vh',
        maxHeight: '80vh',
    },
}));

export const StyledP180ContactText = styled(Text)(({ theme }) => ({
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spaces[2],

    svg: {
        flex: `1 0 ${theme.spaces[5]}`,
        width: theme.spaces[4],
        height: theme.spaces[4],
    },
}));

export const StyledP180FacebookIconWrapper = styled.span({
    display: 'inline-flex',
    color: '#1877F2', // Specific color for Facebook
});
